import { CSSProperties } from "react";

export default class DialogPromptViewStyle {
    prompt: CSSProperties = {
        fontSize: 17,
        lineHeight: '25px',
        color: '#405364',
        fontWeight: 300,
        marginBottom: 0
    }
}